import ZtDriverSpeedAlarmModal from './zt-driver-speed-alarm-modal.vue'
export default ZtDriverSpeedAlarmModal
